// extracted by mini-css-extract-plugin
module.exports = {"block":"Img_block__uk6PT","img-wrapper":"Img_img-wrapper__99YFO","img":"Img_img__WKv_7","content":"Img_content__DiXF6"};